import { useEffect, useState } from "react";

export function useNowMinuteTick(): number {
  const [nowMs, setNowMs] = useState(() => Date.now());

  useEffect(() => {
    setNowMs(Date.now());

    const update = () => setNowMs(Date.now());
    const alignMs = 60_000 - (Date.now() % 60_000);
    let intervalId: number | null = null;

    const alignTimer = window.setTimeout(() => {
      update();
      intervalId = window.setInterval(update, 60_000);
    }, alignMs);

    return () => {
      window.clearTimeout(alignTimer);
      if (intervalId !== null) {
        window.clearInterval(intervalId);
      }
    };
  }, []);

  return nowMs;
}
